<template>
  <div>
    <modal-mensagem
        v-model="modalAvisoBeneficioLocal"
        @modalAcaoCancelar="cancelarAtivarBeneficioRegional"
        @modalAcaoConfirmar="ativarBeneficioRegional"
        text-confirmar="Continuar"
        cor-confirmar="primary"
        :persistencia="true"
        mensagemInicial="Todas as cidades do estado selecionado serão contempladas, deseja continuar?"/>
    <v-layout wrap align-center>
      <v-flex xs12 sm4 d-flex>
        <div class="az-text" v-if="visualizando">
          <label>Modalidade</label>
          <p>{{ getModalidadeLicitacao(value.modalidade) }}</p>
        </div>
        <az-combo-enum-licitacao name="Modalidade" label="Modalidade" placeholder="Selecione"
                                 v-else v-model="value.modalidade" is-required
                                 :disabled="value.publicado || value.origem === 'EXTERNA'"
                                 :enum-object="modalidadesLicitacao" @input="configurarCamposAmparoModalidade"
                                 :error-messages="errors.collect('Modalidade')"
        />
      </v-flex>
      <v-flex xs12 sm4 d-flex>
        <div class="az-text" v-if="visualizando">
          <label>Amparo Legal</label>
          <p>{{ getAmparoLegal }}</p>
        </div>
        <v-select v-else
                  name="Amparo Legal" label="Amparo Legal" placeholder="Selecione"
                  key="AmparoLegal" :return-object="true"
                  class="required-field" v-validate="'required'"
                  :disabled="value.publicado || value.origem === 'EXTERNA'"
                  :loading="amparoLegalLoading"
                  :menu-props="{ top: false, offsetY: true }"
                  v-model="value.amparoLegal"
                  :items="amparosLegais"
                  item-text="lei" item-value="id" :error-messages="errors.collect('Amparo Legal')"
                  @change="configurarAmparoLegalModalidade"
        />
      </v-flex>
      <v-flex xs12 sm4 d-flex>
        <div class="az-text" v-if="visualizando || value.publicado || value.origem === 'EXTERNA'">
          <label>Tipo</label>
          <p>{{ getTipoLicitacao(value.tipoLicitacao) }}</p>
        </div>
        <az-combo-enum-licitacao name="Tipo" label="Tipo" placeholder="Selecione"
                                 v-else v-model="value.tipoLicitacao"
                                 :disabled="value.publicado"
                                 is-required class="required-field"
                                 v-validate="'required'"
                                 :enum-object="getTipoLicitacaoEnum"
                                 @input="setarModoDisputaFechado()"

        />
      </v-flex>
      <v-flex xs12 sm4 d-flex>
        <div class="az-text" v-if="visualizando || value.publicado">
          <label>Id contratação PNCP</label>
          <p>{{value.idContratacaoPncp || '---'}}</p>
        </div>
        <v-text-field name="Id contratação PNCP" label="Id contratação PNCP"
                      placeholder="Ex. 0000000-1-0001/2025"
                      v-model="value.idContratacaoPncp"
                      :class="{ 'required-field' : ehObrigatorioInformarIDContratacaoPNCP }"
                      :disabled="!ehObrigatorioInformarIDContratacaoPNCP"
                      :error-messages="errors.collect('Id contratação PNCP')"
                      v-else
        ></v-text-field>
      </v-flex>
      <v-flex xs12 sm4 d-flex>
        <div class="az-text" v-if="visualizando || value.publicado || value.origem === 'EXTERNA'">
          <label>Número do Processo</label>
          <p>{{ value.numProcesso }}</p>
        </div>
        <v-text-field name="Número do Processo" label="Número do Processo"
                      placeholder="Ex. 000.000.123/2018"
                      v-model="value.numProcesso"
                      v-validate="'required'" class="required-field"
                      :error-messages="errors.collect('Número do Processo')"
                      v-else
        ></v-text-field>
      </v-flex>
      <v-flex xs12 sm4 d-flex>
        <div class="az-text" v-if="possuiApenasUmOrgao || value.publicado || visualizando">
          <label v-if="this.value.ehPerfilComprasBR">Órgão</label>
          <label v-else>Responsável</label>
          <p>{{ orgaoUsuarioDescricao }}</p>
        </div>
        <v-select name="Responsável" :label="labelResponsavel" placeholder="Selecione"
                  :disabled="value.publicado || value.origem === 'EXTERNA'"
                  class="required-field" v-validate="'required'"
                  :menu-props="{ top: false, offsetY: true}"
                  v-model="value.idOrgao"
                  :error-messages="errors.collect('Responsável')"
                  :items="orgaosUsuario"
                  v-else
        >
        </v-select>
      </v-flex>
      <v-flex xs12 sm4 d-flex>
        <div class="az-text licitacao-tipo-disputa" v-if="visualizando || (value.publicado && !permiteEditarDisputaPor)">
          <label>Disputa por</label>
          <p>{{ tipoDisputaDesc }}</p>
        </div>

        <az-combo-enum-licitacao v-else
                                 name="Disputa Por"
                                 label="Disputa Por"
                                 placeholder="Selecione"
                                 v-model="value.tipoDisputa"
                                 :disabled="value.publicado && !permiteEditarDisputaPor"
                                 is-required class="required-field"
                                 v-validate="'required'"
                                 :enum-object="tiposDisputaDisponiveis"
        />
      </v-flex>
      <v-flex xs12 sm4 d-flex>
        <div class="az-text licitacao-comissao" v-if="visualizando  || (value.publicado && !permitindoAlterarDadosPublicados)">
          <label>Comissão</label>
          <p>{{ comissaoDescricao }}</p>
        </div>
        <v-autocomplete
            v-else
            v-model="value.idComissaoApuracao"
            name="Comissão"
            label="Comissão"
            placeholder="Selecione"
            item-text="text"
            item-value="value"
            :items="comissoes"
            :filter="filtroComboAutoCompleteComissao"
            v-validate="'required'"
            class="required-field"
            @change="atualizarResponsaveisPregao"
            :error-messages="errors.collect('Comissão')"/>
      </v-flex>
      <v-flex xs12 sm4 d-flex>
        <div class="az-text licitacao-pregoeiro" v-if="visualizando || (value.publicado && !permitindoAlterarDadosPublicados)">
          <label v-if="ehModalidadeConcorrencia">Agente de Contratação</label>
          <label v-else-if="ehModalidadeLeilao">Leiloeiro</label>
          <label v-else>Pregoeiro</label>
          <p>{{ responsavelDescricao }}</p>
        </div>
        <v-select
            v-else
            :name="labelResponsavelPregao"
            :label="labelResponsavelPregao"
            :placeholder="placeholderResponsavel"
            key="ResponsavelPregao"
            :disabled="(value.publicado && !permitindoAlterarDadosPublicados) || !value.idComissaoApuracao"
            :menu-props="{ top: false, offsetY: true }"
            v-model="value.idResponsavel"
            :items="responsaveisPregao"
            v-validate="'required'"
            class="required-field"
            :error-messages="errors.collect('Responsável')"
        />
      </v-flex>
      <v-flex xs12 sm4 d-flex v-if="ehIntegracaoPrestacaoContasAtiva">
        <div class="az-text licitacao-data-previsao-publicacao"
             v-if="visualizando || value.publicado && value.executarLicitacao">
          <label>Data de Previsão da Publicação</label>
          <p>{{ formatarDataComSegundos(value.dataPrevisaoPublicacao) }}</p>
        </div>
        <az-date-licitacao v-else
                           :disabled="value.publicado || value.executarLicitacao"
                           date-time
                           v-model="value.dataPrevisaoPublicacao"
                           label="Data/Hora de Previsão da Publicação"
                           name-date="Data de Previsão da Publicação"
                           name-hour="Hora de Previsão da Publicação"
                           is-required class="required-field"
                           :enableSeconds="true"
                           disable-past-dates
                           @input="preencherPrevisao"
        ></az-date-licitacao>

      </v-flex>
      <v-flex xs12>
        <v-layout row wrap>
          <v-flex xs12 sm6>
            <div class="az-text licitacao-inicio-envio"
                 v-if="visualizando || (value.publicado && value.executarLicitacao && !permitindoAlterarDadosPublicados)">
              <label>Data/Hora Inicio Envio de Propostas</label>
              <p>{{ formatarDataComSegundos(value.dataIniEnvioProposta) }}</p>
            </div>
            <az-date-licitacao v-else
                               :disabled="(value.publicado && !permitindoAlterarDadosPublicados) || value.executarLicitacao"
                               date-time
                               v-model="value.dataIniEnvioProposta"
                               label="Data/Hora Início Envio de Propostas"
                               name-date="Data Início Envio de Propostas"
                               name-hour="Hora Início Envio de Propostas"
                               is-required class="required-field"
                               :enableSeconds="true"/>
          </v-flex>

          <v-flex xs12 sm6>
            <div class="az-text licitacao-fim-envio"
                 v-if="visualizando || (value.publicado && value.executarLicitacao && !permitindoAlterarDadosPublicados)">
              <label>Data/Hora Fim Envio de Propostas</label>
              <p>{{ formatarDataComSegundos(value.dataFimEnvioProposta) }}</p>
            </div>
            <az-date-licitacao v-else
                               :disabled="(value.publicado && !permitindoAlterarDadosPublicados) || value.executarLicitacao"
                               date-time
                               v-model="value.dataFimEnvioProposta"
                               label="Data/Hora Fim Envio de Propostas"
                               name-date="Data Fim Envio de Propostas"
                               name-hour="Hora Fim Envio de Propostas"
                               is-required class="required-field"
                               :enableSeconds="true"/>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12>
        <v-layout row wrap>
          <v-flex xs12 sm6>
            <div class="az-text licitacao-inicio-envio">
              <label>Data/Hora Inicio Envio de Propostas (Horário de Brasília)</label>
              <p>{{ formatarDataBSB(value.dataIniEnvioProposta) }}</p>
            </div>

          </v-flex>
          <v-flex xs12 sm6>
            <div class="az-text licitacao-fim-envio">
              <label>Data/Hora Fim Envio de Propostas (Horário de Brasília)</label>
              <p>{{ formatarDataBSB(value.dataFimEnvioProposta) }}</p>
            </div>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 sm4 d-flex>
        <div class="az-text licitacao-abertura" v-if="visualizando || (value.publicado && value.executarLicitacao && !permitindoAlterarDadosPublicados)">
          <label>Data/Hora Abertura Licitação
            <v-icon title="Abertura de Proposta/Início da Disputa" size="15">info</v-icon>
          </label>
          <p>{{ formatarDataComSegundos(value.dataAbertura) }}</p>
        </div>
        <az-date-licitacao v-else
                           :disabled="(value.publicado && !permitindoAlterarDadosPublicados) || value.executarLicitacao"
                           date-time
                           v-model="value.dataAbertura"
                           label="Data/Hora Abertura Licitação"
                           name-date="Data Abertura Licitação"
                           name-hour="Hora Abertura Licitação"
                           is-required class="required-field"
                           :data-minima="value.dataPrevisaoPublicacao"
                           :enableSeconds="true"
                           :is-disabled="!this.dataPrevisaoPreenchida && ehIntegracaoPrestacaoContasAtiva"
        ></az-date-licitacao>
      </v-flex>
      <v-flex xs12 sm4 d-flex>
        <div class="az-text licitacao-limite-esclarecimento-impugnacao"
             v-if="visualizando || (value.publicado && value.executarLicitacao && !permitindoAlterarDadosPublicados)">
          <label>Data/Hora Limite Esclarecimento/Impugnação</label>
          <p>{{ formatarDataComSegundos(value.dataLimiteEsclarecimentoImpugnacao) }}</p>
        </div>
        <az-date-licitacao v-else
                           :disabled="(value.publicado && !permitindoAlterarDadosPublicados) || value.executarLicitacao"
                           date-time
                           v-model="value.dataLimiteEsclarecimentoImpugnacao"
                           label="Data/Hora Limite Esclarecimento/Impugnação"
                           name-date="Data Limite Esclarecimento/Impugnação"
                           name-hour="Hora Limite Esclarecimento/Impugnação"
                           :enableSeconds="true"
                           default-time="23:59:59"
        ></az-date-licitacao>
      </v-flex>
      <v-flex xs12 sm4 d-flex>
        <div class="az-text licitacao-tipo-disputa" v-if="(visualizando || (value.publicado && !permitindoAlterarDadosPublicados)) && value.categoria">
          <label>Categoria</label>
          <p>{{ value.categoria.descricao }}</p>
        </div>

        <v-select v-if="!visualizando && (!value.publicado || permitindoAlterarDadosPublicados)"
                  name="Categoria" label="Categoria" placeholder="Selecione"
                  key="Categoria" :return-object="true"
                  class="required-field" v-validate="'required'"
                  :disabled="value.publicado && !permitindoAlterarDadosPublicados"
                  :menu-props="{ top: false, offsetY: true }"
                  v-model="value.categoria"
                  :items="categorias"
                  item-text="descricao" item-value="tipo"
                  :error-messages="errors.collect('Categoria')"
                  @input="setarCategoriaId"
        />
      </v-flex>
      <v-flex xs12 sm4 d-flex v-if="getEspecificacoesRamo">
        <div class="az-text licitacao-tipo-disputa" v-if="(visualizando || value.publicado) && value.especificacaoRamo">
          <label>Especificação Ramo</label>
          <p>{{ value.especificacaoRamo.descricao }}</p>
        </div>
        <v-select v-if="!visualizando && !value.publicado"
                  name="Especificação Ramo" label="Especificação Ramo" placeholder="Selecione"
                  key="EspecificacaoRamo" :return-object="true"
                  class="required-field" v-validate="'required'"
                  :disabled="value.publicado"
                  :menu-props="{ top: false, offsetY: true }"
                  v-model="value.especificacaoRamo"
                  :items="especificacoesRamo"
                  item-text="descricao" item-value="id"
                  :error-messages="errors.collect('Especificação Ramo')"
                  @input="setarEspecificacaoRamoId"
        />
      </v-flex>
      <v-flex xs12 sm4 d-flex>
        <div class="az-text licitacao-vl-reserva" v-if="visualizando || (value.publicado && !permitindoAlterarDadosPublicados)">
          <label>Habilitar Esclarecimentos e Impugnações</label>
          <p>{{ value.esclarecimentoImpugnacao ? 'Sim' : 'Não' }}</p>
        </div>
        <div class="az-checkbox" v-else>
          <div class="checkbox-label">
            Habilitar Esclarecimentos e Impugnações
          </div>
          <div>
            <v-radio-group row name="Habilitar Esclarecimentos e Impugnações"
                           :disabled="value.publicado || value.origem === 'EXTERNA'"
                           v-model="value.esclarecimentoImpugnacao"
                           v-validate="'required'"
                           :error-messages="errors.collect('Habilitar Esclarecimentos e Impugnações')">
              <v-radio label="Sim" :value="true"></v-radio>
              <v-radio label="Não" :value="false"></v-radio>
            </v-radio-group>
          </div>
        </div>
      </v-flex>
      <v-flex xs12 sm2 d-flex>
        <div class="az-text licitacao-registro-preco" v-if="visualizando || value.origem === 'EXTERNA'">
          <label>Registro de Preço</label>
          <p>{{ value.registroPreco | opcaoSimNaoFilter }}</p>
        </div>
        <div class="az-checkbox" v-else>
          <div class="checkbox-label">
            Registro de Preço
          </div>
          <div>
            <v-radio-group row name="Registro de Preço"
                           :disabled="value.publicado && !permitindoAlterarDadosPublicados"
                           v-model="value.registroPreco"
                           v-validate="'required'"
                           :error-messages="errors.collect('Registro de Preço')">
              <v-radio v-for="(value, key) in opcaoSimNao"
                       :key="key" :label="value" :value="key"></v-radio>
            </v-radio-group>
          </div>
        </div>
      </v-flex>
      <v-flex xs12 sm2 d-flex>
        <div class="az-text licitacao-vl-reserva" v-if="visualizando">
          <label>Exibir Valor de Referência</label>
          <p>{{ value.mostrarValorReserva ? 'Sim' : 'Não' }}</p>
        </div>
        <div class="az-checkbox" v-else>
          <div class="checkbox-label">
            Exibir Valor de Referência
          </div>
          <div>
            <v-radio-group row name="Exibir Valor de Referência"
                           :disabled="value.publicado"
                           v-model="value.mostrarValorReserva"
                           v-validate="'required'"
                           :error-messages="errors.collect('Exibir Valor Reserva')">
              <v-radio label="Sim" :value="true"></v-radio>
              <v-radio label="Não" :value="false"></v-radio>
            </v-radio-group>
          </div>
        </div>
      </v-flex>
      <v-flex xs12 sm2 d-flex>
        <div class="az-text" v-if="visualizando || value.origem === 'EXTERNA'">
          <label>Casas Decimais</label>
          <p>{{ value.casasDecimais }}</p>
        </div>
        <v-select name="Casas Decimais Valor" label="Casas Decimais Valor" placeholder="Selecione"
                  v-model="value.casasDecimais"
                  v-validate="'required'"
                  :disabled="value.publicado"
                  :error-messages="errors.collect('Casas Decimais Valor')"
                  :items="casasDecimais"
                  v-else
        ></v-select>
      </v-flex>
      <v-flex xs12 sm2 d-flex>
        <div class="az-text" v-if="visualizando || value.origem === 'EXTERNA'">
          <label>Casas Decimais Quantidade</label>
          <p>{{ value.casasDecimaisQuantidade }}</p>
        </div>
        <v-select name="Casas Decimais Quantidade" label="Casas Decimais Quantidade" placeholder="Selecione"
                  v-model="value.casasDecimaisQuantidade"
                  v-validate="'required'"
                  :disabled="value.publicado"
                  :error-messages="errors.collect('Casas Decimais Quantidade')"
                  :items="casasDecimaisQuantidade"
                  v-else
        ></v-select>
      </v-flex>
      <v-flex xs12 sm4 d-flex>
        <div class="az-text" v-if="visualizando || (value.publicado && !permitindoAlterarDadosPublicados)">
          <label>Modo de Disputa</label>
          <p>{{ getModoDisputa(value.modoDisputa) }}</p>
        </div>
        <v-select
            v-else
            name="Modo de Disputa"
            label="Modo de Disputa"
            placeholder="Selecione"
            v-model="modoDisputaValue"
            :items="modoDisputaPregao"
            :disabled="value.publicado && !permitindoAlterarDadosPublicados"
            v-validate="{ required: true }" class="required-field"
            :error-messages="errors.collect('Modo de Disputa')"
            :menu-props="{ top: false, offsetY: true }"
        />
      </v-flex>

      <v-flex xs12 sm4 d-flex v-if="value.modoDisputa === 'ABERTO' || value.modoDisputa === 'FECHADO_ABERTO'">
        <div class="az-text" v-if="visualizando">
          <label>Tempo da Fase de Lances (Minutos)</label>
          <p>{{ value.tempoFaseLance }}</p>
        </div>
        <v-text-field name="tempoFaseLance" label="Tempo da Fase de Lances (Minutos)"
                      placeholder="10"
                      :disabled="value.publicado"
                      v-model="value.tempoFaseLance"
                      readonly
                      v-else
        ></v-text-field>
      </v-flex>

      <v-flex xs12 sm4 d-flex v-if="value.modoDisputa === 'ABERTO_FECHADO'">
        <div class="az-text">
          <label>Tempo na Etapa Lance Final (Minutos)</label>
          <p>{{ value.etapaLanceFinal }}</p>
        </div>
      </v-flex>

      <v-flex xs12 sm2 d-flex
              v-if="value.modoDisputa === 'ABERTO' || value.modoDisputa === 'ABERTO_FECHADO' || value.modoDisputa === 'FECHADO_ABERTO'">
        <div class="az-text" v-if="visualizando">
          <label>Informar Diferença Mínima entre Lances</label>
          <p>{{ value.diferencaMinimaLance }}</p>
        </div>
        <div v-else>
          <v-text-field name="diferencaMinimaLance" label="Informar Diferença Mínima entre Lances"
                        placeholder="1"
                        :disabled="value.publicado"
                        v-model="value.diferencaMinimaLance"
                        type="number"
                        data-vv-as="Informar Diferença Mínima entre Lances"
                        v-validate="'required|min_value:0|decimal:' + value.casasDecimais" class="required-field"
                        :error-messages="errors.collect('diferencaMinimaLance')"
                        v-if="value.modoDisputa === 'ABERTO' || value.modoDisputa === 'FECHADO_ABERTO'"
          />
          <v-text-field name="diferencaMinimaLance" label="Informar Diferença Mínima entre Lances"
                        placeholder="1"
                        :disabled="value.publicado"
                        data-vv-as="Informar Diferença Mínima entre Lances"
                        v-validate="'required|min_value:0|decimal:' + value.casasDecimais" class="required-field"
                        :error-messages="errors.collect('diferencaMinimaLance')"
                        v-model="value.diferencaMinimaLance"
                        type="number"
                        v-if="value.modoDisputa === 'ABERTO_FECHADO'"
          />
        </div>
      </v-flex>

      <v-flex xs12 sm2 d-flex
              v-if="value.modoDisputa === 'ABERTO' || value.modoDisputa === 'ABERTO_FECHADO' || value.modoDisputa === 'FECHADO_ABERTO'">
        <v-select v-model="value.diferencaMinimaLancePercentual"
                  :items="itemsTipoLances"
                  item-text="text"
                  item-value="value"
                  :disabled="value.publicado"
                  :readonly="visualizando"
                  :menu-props="{ top: false, offsetY: true }"
        ></v-select>
      </v-flex>
      <v-flex xs12 sm2 d-flex>
        <div class="az-text licitacao-vl-reserva" v-if="visualizando || (value.publicado && !permitindoAlterarDadosPublicados)">
          <label>Inversão de Fases</label>
          <p>{{ value.inversaoFases ? 'Sim' : 'Não' }}</p>
        </div>
        <div class="az-checkbox" v-else>
          <div class="checkbox-label">
            Inversão de Fases
          </div>
          <div>
            <v-radio-group row name="Inversão de Fases"
                           v-model="value.inversaoFases"
                           v-validate="'required'"
                           :disabled="(value.publicado && !permitindoAlterarDadosPublicados) || bloquearInversaoDeFases"
                           :error-messages="errors.collect('Inversão de Fases')">
              <v-radio label="Sim" :value="true"></v-radio>
              <v-radio label="Não" :value="false"></v-radio>
            </v-radio-group>
          </div>
        </div>
      </v-flex>
      <v-flex xs12 sm2 d-flex>
        <div class="az-text licitacao-vl-reserva" v-if="visualizando || (value.publicado && !permitindoAlterarDadosPublicados)">
          <label>Utilizar Moeda Estrangeira</label>
          <p>{{ value.utilizaMoedaEstrangeira ? 'Sim' : 'Não' }}</p>
        </div>
        <div class="az-checkbox" v-else>
          <div class="checkbox-label">
            Utilizar Moeda Estrangeira
          </div>
          <div>
            <v-radio-group row name="Utiliza Moeda Estrangeira"
                           v-model="value.utilizaMoedaEstrangeira"
                           v-validate="'required'"
                           :disabled="value.publicado && !permitindoAlterarDadosPublicados"
                           :error-messages="errors.collect('Utilizar Moeda Estrangeira')">
              <v-radio label="Sim" :value="true"></v-radio>
              <v-radio label="Não" :value="false"></v-radio>
            </v-radio-group>
          </div>
        </div>
      </v-flex>
      <v-flex xs12 sm2 d-flex>
        <div class="az-text licitacao-vl-reserva" v-if="visualizando  || (value.publicado && !permitindoAlterarDadosPublicados)">
          <label>Recurso Federal</label>
          <p>{{ value.recursoFederal ? 'Sim' : 'Não' }}</p>
        </div>
        <div class="az-checkbox" v-else>
          <div class="checkbox-label">
            Recurso Federal
          </div>
          <div>
            <v-radio-group row name="Recurso Federal"
                           v-model="value.recursoFederal"
                           v-validate="'required'"
                           :error-messages="errors.collect('Recurso Federal')"
                           v-on:click="anularAtributosRecursoFederal()">
              <v-radio label="Sim" :value="true"></v-radio>
              <v-radio label="Não" :value="false"></v-radio>
            </v-radio-group>
          </div>
        </div>
      </v-flex>
      <v-flex xs12 sm2 d-flex v-if="value.recursoFederal">
        <div class="az-text" v-if="visualizando  || value.publicado">
          <label>Tipo Transferência</label>
          <p>{{ getTipoTransferencia(value.tipoTransferencia) }}</p>
        </div>
        <az-combo-enum name="Tipo Transfência" label="Tipo Transferência" placeholder="Selecione"
                       v-else v-model="value.tipoTransferencia" is-required
                       :disabled="value.origem === 'EXTERNA'"
                       :enum-object="tipoTransferencia"
        ></az-combo-enum>
      </v-flex>
      <v-flex xs12 sm12 d-flex v-if="value.recursoFederal && value.tipoTransferencia === 'VOLUNTARIAS'">
        <v-flex xs12 sm4 d-flex>
          <div class="az-text" v-if="visualizando || value.publicado">
            <label>Nº do Convênio</label>
            <p>{{ value.numeroConvenio }}</p>
          </div>
          <v-text-field name="Nº do Convênio" label="Nº do Convênio"
                        placeholder="Ex. 000000123-2018"
                        v-model="value.numeroConvenio"
                        :disabled="value.origem === 'EXTERNA'"
                        :maxlength="30" class="required-field"
                        v-validate="{rules: {required:value.tipoTransferencia === 'VOLUNTARIAS', max:30}}"
                        :error-messages="errors.collect('Nº do Convênio')"
                        v-else
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm4 d-flex>
          <div class="az-text" v-if="visualizando || value.publicado">
            <label>Nº Compra</label>
            <p>{{ value.numeroCompra }}</p>
          </div>
          <v-text-field name="Nº Compra" label="Nº Compra"
                        placeholder="Ex. 1"
                        v-model="value.numeroCompra"
                        :disabled="value.origem === 'EXTERNA'"
                        :maxlength="10"
                        type="number" class="required-field"
                        v-validate="{rules: {required:value.tipoTransferencia === 'VOLUNTARIAS', max:10}}"
                        :error-messages="errors.collect('Nº Compra')"
                        v-else
          ></v-text-field>
        </v-flex>

        <v-flex xs12 sm4 d-flex>
          <div class="az-text" v-if="visualizando || value.publicado">
            <label>Ano Instrumento</label>
            <p>{{ value.anoInstrumento }}</p>
          </div>
          <v-text-field name="Ano Instrumento" label="Ano Instrumento"
                        placeholder="Ex. 1999"
                        v-model="value.anoInstrumento"
                        :disabled="value.origem === 'EXTERNA'"
                        :maxlength="10"
                        type="number" class="required-field"
                        v-validate="{rules: {required:value.tipoTransferencia === 'VOLUNTARIAS', min:4, max:4}}"
                        :error-messages="errors.collect('Ano Instrumento')"
                        v-else
          ></v-text-field>
        </v-flex>
      </v-flex>
      <v-flex xs12 sm12 d-flex v-if="value.recursoFederal && value.tipoTransferencia === 'VOLUNTARIAS'">
        <v-flex xs12 sm4 d-flex>
          <div class="az-text" v-if="visualizando || value.publicado">
            <label>Legislação</label>
            <p>{{ getLegislacao(value.legislacao) }}</p>
          </div>
          <az-combo-enum name="Legislação" label="Legislação" placeholder="Selecione"
                         v-else v-model="value.legislacao" is-required class="required-field"
                         :disabled="value.origem === 'EXTERNA'"
                         :enum-object="legislacao"
          ></az-combo-enum>
        </v-flex>

        <v-flex xs12 sm4 d-flex>
          <div class="az-text" v-if="visualizando || value.publicado">
            <label>Tipo Objeto</label>
            <p>{{ getTipoObjeto(value.tipoObjeto) }}</p>
          </div>
          <az-combo-enum name="Tipo Objeto" label="Tipo Objeto" placeholder="Selecione"
                         v-else v-model="value.tipoObjeto" is-required class="required-field"
                         :enum-object="tipoObjeto"
          ></az-combo-enum>
        </v-flex>
        <v-flex xs12 sm4 d-flex>
          <div class="az-text" v-if="visualizando || value.publicado">
            <label>Origem Recurso</label>
            <p>{{ getOrigemRecurso(value.origemRecurso) }}</p>
          </div>
          <az-combo-enum name="Origem Recurso" label="Origem Recurso" placeholder="Selecione"
                         v-else v-model="value.origemRecurso" is-required class="required-field"
                         :disabled="value.origem === 'EXTERNA'"
                         :enum-object="origemRecurso"
          ></az-combo-enum>
        </v-flex>
      </v-flex>

      <v-flex xs12 sm2 md2 d-flex v-if="exibirAno">
        <div class="az-text" v-if="visualizando || value.publicado">
          <label>Ano</label>
          <p>{{ value.anoCompra || '--' }}</p>
        </div>
        <v-text-field v-else
                      name="Ano" label="Ano"
                      :placeholder="'Ex. ' + new Date().getFullYear()"
                      v-model="value.anoCompra"
                      type="number"
                      v-validate="'required|min:4|max:4'"
                      :error-messages="errors.collect('Ano')"
        ></v-text-field>
      </v-flex>
      <v-flex xs12 sm12 d-flex>
        <div v-if="value.existeLotesExclusivos">
          <v-card outlined :elevation="0" class="beneficio-local-card">
            <v-toolbar :flat=true :dense=true class="beneficio-local-toolbar">
              <v-toolbar-items class="regimento-beneficio">
                <label class="v-toolbar__title caption">Benefício ME/EPP/MEI Local</label>
                <v-checkbox label="Sim" class="beneficio-local-checkbox" v-model="beneficioLocal.ativado"
                            v-on:change="validarAtivarBeneficioRegional"
                            :disabled="visualizando || (value.publicado && !permitindoAlterarDadosPublicados)"></v-checkbox>
                <div v-if="beneficioLocal.ativado">
                  <v-tooltip top max-width=750 :disabled="visualizando || (value.publicado && !permitindoAlterarDadosPublicados)">
                    <div slot="activator" class="separadorBeneficioLocal">
                      <label class="v-toolbar__title caption">Regional</label>
                      <v-checkbox label="Sim" class="beneficio-local-checkbox" v-model="value.beneficioRegional"
                                  :disabled="visualizando || (value.publicado && !permitindoAlterarDadosPublicados)" v-on:change="controlarRegimento"/>
                    </div>
                    <span>Somente participam as empresas locais ou regionais selecionadas abaixo, caso o órgão possua uma legislação específica.</span>
                  </v-tooltip>
                </div>
                <div class="separadorBeneficioLocal" v-if="value.beneficioRegional" slot="activator">
                  <v-tooltip top max-width=750 :disabled="visualizando || (value.publicado && !permitindoAlterarDadosPublicados)">
                    <div class="regimento-beneficio" slot="activator">
                      <label class="v-toolbar__title caption regimento-label">Legislação:</label>
                      <span v-if="visualizando || (value.publicado && !permitindoAlterarDadosPublicados)">{{ value.regimento }}</span>
                      <v-text-field name="Regimento" v-if="!visualizando && (!value.publicado || permitindoAlterarDadosPublicados)"
                                    v-model="value.regimento"
                                    :maxlength="250"
                                    class="required-field"
                                    v-validate="{rules: {required:value.beneficioRegional}}"
                                    :error-messages="errors.collect('Regimento')"
                      />
                    </div>
                    <span>Informe a legislação que regulamenta esse benefício.</span>
                  </v-tooltip>
                </div>
              </v-toolbar-items>
            </v-toolbar>
            <v-expand-transition>
              <v-card-text v-show="beneficioLocal.ativado">
                <v-layout row v-if="!visualizando && (!value.publicado || permitindoAlterarDadosPublicados)">
                  <v-flex>
                    <v-select name="beneficioLocalEstado" label="Estado" placeholder="Selecione"
                              :items="ufs" item-text="nome" item-value="id" v-model="beneficioLocal.ufSelecionada"
                              v-on:change="buscarMunicipios"></v-select>
                  </v-flex>
                  <v-flex>
                    <v-autocomplete
                        v-model="beneficioLocal.cidadeSelecionada"
                        class="municipio-beneficio"
                        name="beneficioLocalCidade" label="Cidade" placeholder="Selecione"
                        item-text="nome" item-value="id"
                        :items="beneficioLocal.municipiosUf"
                        :filter="filtroComboAutoComplete"
                        multiple>
                      <template v-slot:selection="{ item, index }">
                                                      <span v-if="index === 0">
                                                        {{ item.nome }}&nbsp;
                                                      </span>
                        <span
                            v-if="index === 1"
                            class="grey--text text-caption"
                        >
                                                      (+{{ beneficioLocal.cidadeSelecionada.length - 1 }} outras)
                                                       </span>
                      </template>
                      <template v-slot:prepend-item>
                        <v-list-tile
                            name="list-item"
                            ripple
                            @mousedown.prevent
                            @click="selecionarTodosMunicipiosUf"
                        >
                          <div class="selecionar-todos-municipios-btn">
                            <v-icon size="14"> {{ iconeSelecionarMunicipios }}</v-icon>
                            <label class="ml-1">Selecionar Todos</label>
                          </div>
                        </v-list-tile>
                        <v-divider class="mt-2"></v-divider>
                      </template>
                    </v-autocomplete>
                  </v-flex>
                  <v-flex>
                    <v-btn color="success" :depressed=true @click="adicionarBeneficioRegional">Adicionar</v-btn>
                    <v-btn :depressed=true @click="limparListaBeneficioRegional">Limpar</v-btn>
                  </v-flex>
                </v-layout>
                <v-list v-if="value.beneficiosRegionais">
                  <template v-for="(item,index) in value.beneficiosRegionais">
                    <v-list-tile class="beneficio-local-item" :key="item.index">
                      <v-layout row grow>
                        <v-flex align-self-center xs10>
                          <v-list-tile-title class="caption" v-if=item.municipio>
                            {{ index + 1 }}. {{ item.municipio.nome }} - {{ item.municipio.estado.sigla }}
                            ({{ item.beneficioLocal ? 'BENEFÍCIO LOCAL' : 'BENEFÍCIO REGIONAL' }})
                          </v-list-tile-title>
                          <v-list-tile-title class="caption" v-else>
                            {{ index + 1 }}. {{ item.estado.nome }} ({{ item.beneficioLocal ? 'BENEFÍCIO LOCAL' : 'BENEFÍCIO REGIONAL' }})
                          </v-list-tile-title>
                        </v-flex>
                        <v-flex align-self-center xs2 text-xs-center v-if="!visualizando && !value.publicado">
                          <v-btn icon flat @click="removerBeneficioLocal(index)">
                            <v-icon small>remove_circle</v-icon>
                          </v-btn>
                        </v-flex>
                      </v-layout>
                    </v-list-tile>
                  </template>
                </v-list>
              </v-card-text>
            </v-expand-transition>
          </v-card>
        </div>
      </v-flex>

      <v-flex xs12 sm12 d-flex>
        <div class="az-text" v-if="visualizando">
          <label>Objeto</label>
          <p>{{ value.objeto }}</p>
        </div>
        <div v-else>
          <v-textarea name="Objeto" label="Objeto" v-model="value.objeto"
                      placeholder="Ex. Compra de Material de Expediente"
                      required :readonly="visualizando"
                      :disabled="value.publicado || value.origem === 'EXTERNA'"
                      :maxlength="5000" class="required-field"
                      v-validate="{rules: {required:true, max:5000}}"
                      :error-messages="errors.collect('Objeto')"
          ></v-textarea>
          <p class="az-text" style="float: right">
            {{ 5000 - (value.objeto ? value.objeto.length : 0) }}
          </p>
        </div>
      </v-flex>

      <v-flex xs12 sm12 d-flex>
        <div class="az-text" v-if="visualizando || value.publicado">
          <label>Informação Complementar</label>
          <p>{{ value.informacaoComplementar || '--' }}</p>
        </div>
        <div v-else>
          <v-textarea name="Informação Complementar" label="Informação Complementar"
                      v-model="value.informacaoComplementar"
                      placeholder="Ex. Informação Complementar"
                      :readonly="visualizando"
                      rows="1"
                      :maxlength="500"
                      v-validate="{rules: {max:500}}"
                      :error-messages="errors.collect('Informação Complementar')"
          ></v-textarea>
          <p class="az-text" style="float: right">
            {{ 500 - (value.informacaoComplementar ? value.informacaoComplementar.length : 0) }}
          </p>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import {
  actionTypes,
  formatosDefault,
  modalidadesLicitacao,
  modoDisputa,
  opcaoSimNao,
  tiposDisputa,
  tiposLicitacao,
  tiposLicitacaoSemMaiorOferta,
  tiposLicitacaoComTecnicaPreco,
  legislacao,
  tipoObjeto,
  origemRecurso,
  tipoTransferencia,
  tiposLicitacaoLeilao
} from '@/commons/constants'
import AzComboEnumLicitacao from '@/commons/components/AzComboEnumLicitacao'
import AzDateLicitacao from '@/commons/components/AzDateLicitacao'
import moment from "moment"
import {mapState} from 'vuex'
import momentTz from 'moment-timezone'
import ModalMensagem from "@/commons/components/ModalMensagem.vue";

export default {
  name: 'DadosGerais',
  components: {ModalMensagem, AzComboEnumLicitacao, AzDateLicitacao},
  inject: ['$validator'],
  props: {
    acao: {
      type: String,
      validator: val => ['inserindo', 'editando', 'alterando-dados', 'visualizando'].includes(val),
      default: 'visualizando'
    },
    value: {
      required: true
    },
    exibirAno: {
      type: Boolean
    }
  },
  data() {
    return {
      comissoes: [],
      responsaveisPregao: [],
      dataPrevisaoPreenchida: false,
      orgaosUsuario: [],
      casasDecimais: [],
      casasDecimaisQuantidade: [],
      formatoData: formatosDefault.DATA_HORA,
      modalidadesLicitacao,
      modoDisputa,
      opcaoSimNao,
      tiposDisputa,
      tiposLicitacao,
      legislacao,
      tipoObjeto,
      origemRecurso,
      tipoTransferencia,
      tipoLances: [
        {
          text: 'Valor (R$)',
          value: false
        },
        {
          text: 'Percentual (%)',
          value: true
        }
      ],
      tipoLancesMD: [
        {
          text: 'Percentual (%)',
          value: true
        }
      ],
      beneficioLocal: {
        ativado: false,
        municipiosUf: [],
        cidadeSelecionada: []
      },
      ufs: [],
      orgaoUsuario: null,
      cachedModoDisputa: null,
      modoDisputaPregao: [
        {text: 'Aberto', value: 'ABERTO', disabled: false},
        {text: 'Aberto/Fechado', value: 'ABERTO_FECHADO', disabled: false},
        {text: 'Randômico', value: 'RANDOMICO', disabled: false},
        {text: 'Fechado', value: 'FECHADO', disabled: false},
        {text: 'Fechado/Aberto', value: 'FECHADO_ABERTO', disabled: false},
      ],
      modoDisputaAmparoLegal: [
        {
          codigoAmparoLegal: '0', modoDisputaAmparo: [
            {text: 'Aberto', value: 'ABERTO', disabled: true},
            {text: 'Aberto/Fechado', value: 'ABERTO_FECHADO', disabled: true},
            {text: 'Randômico', value: 'RANDOMICO', disabled: false},
            {text: 'Fechado', value: 'FECHADO', disabled: true},
            {text: 'Fechado/Aberto', value: 'FECHADO_ABERTO', disabled: true}
          ],
          modoDisputa: 'RANDOMICO',
          bloquearInversaoDeFases: true
        },
        {
          codigoAmparoLegal: '-1', modoDisputaAmparo: [
            {text: 'Aberto', value: 'ABERTO', disabled: true},
            {text: 'Aberto/Fechado', value: 'ABERTO_FECHADO', disabled: true},
            {text: 'Randômico', value: 'RANDOMICO', disabled: false},
            {text: 'Fechado', value: 'FECHADO', disabled: true},
            {text: 'Fechado/Aberto', value: 'FECHADO_ABERTO', disabled: true}
          ],
          modoDisputa: 'RANDOMICO',
          bloquearInversaoDeFases: true
        },
        {
          codigoAmparoLegal: '-3', modoDisputaAmparo: [
            {text: 'Aberto', value: 'ABERTO', disabled: false},
            {text: 'Aberto/Fechado', value: 'ABERTO_FECHADO', disabled: false},
            {text: 'Randômico', value: 'RANDOMICO', disabled: true},
            {text: 'Fechado', value: 'FECHADO', disabled: true},
            {text: 'Fechado/Aberto', value: 'FECHADO_ABERTO', disabled: true}
          ],
          modoDisputa: null,
          bloquearInversaoDeFases: true
        },
        {
          codigoAmparoLegal: '1', modoDisputaAmparo: [
            {text: 'Aberto', value: 'ABERTO', disabled: false},
            {text: 'Aberto/Fechado', value: 'ABERTO_FECHADO', disabled: false},
            {text: 'Randômico', value: 'RANDOMICO', disabled: true},
            {text: 'Fechado', value: 'FECHADO', disabled: true},
            {text: 'Fechado/Aberto', value: 'FECHADO_ABERTO', disabled: false}
          ],
          modoDisputa: null,
          bloquearInversaoDeFases: false
        },
        {
          codigoAmparoLegal: '2', modoDisputaAmparo: [
            {text: 'Aberto', value: 'ABERTO', disabled: false},
            {text: 'Aberto/Fechado', value: 'ABERTO_FECHADO', disabled: false},
            {text: 'Randômico', value: 'RANDOMICO', disabled: true},
            {text: 'Fechado', value: 'FECHADO', disabled: false},
            {text: 'Fechado/Aberto', value: 'FECHADO_ABERTO', disabled: false}
          ],
          modoDisputa: null,
          bloquearInversaoDeFases: false
        },
        {
          codigoAmparoLegal: '3', modoDisputaAmparo: [
            {text: 'Aberto', value: 'ABERTO', disabled: false},
            {text: 'Aberto/Fechado', value: 'ABERTO_FECHADO', disabled: false},
            {text: 'Randômico', value: 'RANDOMICO', disabled: true},
            {text: 'Fechado', value: 'FECHADO', disabled: false},
            {text: 'Fechado/Aberto', value: 'FECHADO_ABERTO', disabled: false}
          ],
          modoDisputa: null,
          bloquearInversaoDeFases: false
        },
        {
          codigoAmparoLegal: '5', modoDisputaAmparo: [
            {text: 'Aberto', value: 'ABERTO', disabled: false},
            {text: 'Aberto/Fechado', value: 'ABERTO_FECHADO', disabled: false},
            {text: 'Randômico', value: 'RANDOMICO', disabled: true},
            {text: 'Fechado', value: 'FECHADO', disabled: false},
            {text: 'Fechado/Aberto', value: 'FECHADO_ABERTO', disabled: false}
          ],
          modoDisputa: null,
          bloquearInversaoDeFases: false
        },
        {
          codigoAmparoLegal: '-2', modoDisputaAmparo: [
            {text: 'Aberto', value: 'ABERTO', disabled: false},
            {text: 'Aberto/Fechado', value: 'ABERTO_FECHADO', disabled: false},
            {text: 'Randômico', value: 'RANDOMICO', disabled: true},
            {text: 'Fechado', value: 'FECHADO', disabled: true},
            {text: 'Fechado/Aberto', value: 'FECHADO_ABERTO', disabled: true}
          ],
          modoDisputa: null,
          bloquearInversaoDeFases: false
        },
        {
          codigoAmparoLegal: '-4', modoDisputaAmparo: [
            {text: 'Aberto', value: 'ABERTO', disabled: false},
            {text: 'Aberto/Fechado', value: 'ABERTO_FECHADO', disabled: false},
            {text: 'Randômico', value: 'RANDOMICO', disabled: true},
            {text: 'Fechado', value: 'FECHADO', disabled: true},
            {text: 'Fechado/Aberto', value: 'FECHADO_ABERTO', disabled: false}
          ],
          modoDisputa: null,
          bloquearInversaoDeFases: false
        },
        {
          codigoAmparoLegal: '4', modoDisputaAmparo: [
            {text: 'Aberto', value: 'ABERTO', disabled: false},
            {text: 'Aberto/Fechado', value: 'ABERTO_FECHADO', disabled: false},
            {text: 'Randômico', value: 'RANDOMICO', disabled: true},
            {text: 'Fechado', value: 'FECHADO', disabled: true},
            {text: 'Fechado/Aberto', value: 'FECHADO_ABERTO', disabled: false}
          ],
          modoDisputa: null,
          bloquearInversaoDeFases: true
        }

      ],
      modoDisputaNaoExecutaveis: [
        {text: 'Aberto', value: 'ABERTO', disabled: false},
        {text: 'Aberto/Fechado', value: 'ABERTO_FECHADO', disabled: false},
        {text: 'Fechado', value: 'FECHADO', disabled: false},
        {text: 'Fechado/Aberto', value: 'FECHADO_ABERTO', disabled: false},
        {text: 'Não se Aplica', value: 'NAO_SE_APLICA', disabled: false}
      ],
      bloquearInversaoDeFases: false,
      amparosLegais: [],
      amparoLegalLoading: false,
      categorias: [],
      especificacoesRamo: [],
      modalAvisoBeneficioLocal: false
    }
  },
  computed: {
    modoDisputaValue: {
      get() {
        return this.cachedModoDisputa || this.value.modoDisputa;
      },
      set(value) {
        this.value.modoDisputa = value;
        this.cachedModoDisputa = value;
      }
    },
    tiposDisputaDisponiveis() {
      const tiposDisputaDisponiveis = { ...this.tiposDisputa }

      if (this.ehAmparoLei14133Art82) {
        delete tiposDisputaDisponiveis.VALOR_TOTAL
      }

      return tiposDisputaDisponiveis
    },
    iconeSelecionarMunicipios() {
      if (this.todosMunicipiosSelecionados) return 'check_box'
      return 'check_box_outline_blank'
    },
    todosMunicipiosSelecionados() {
      return this.beneficioLocal.cidadeSelecionada.length === this.beneficioLocal.municipiosUf.length
    },
    comissaoDescricao() {
      let comissaoDescricao = ''
      this.comissoes.forEach(comissao => {
        if (comissao.value === this.value.idComissaoApuracao) {
          comissaoDescricao = comissao.text
        }
      })
      return comissaoDescricao
    },
    orgaoUsuarioDescricao() {
      if (this.value.nomeOrgao)
        return `${this.value.nomeOrgao} - ${this.value.siglaOrgao}`
      if (this.possuiApenasUmOrgao && this.orgaosUsuario.length > 0) {
        let index = this.orgaosUsuario.map(orgao => orgao.value).indexOf(this.value.idOrgao)
        return this.orgaosUsuario[index].text
      }
    },
    pregoeiro() {
      let pregoeiro = ''
      this.comissoes.forEach(comissao => {
        if (comissao.value === this.value.idComissaoApuracao) {
          pregoeiro = comissao.pregoeiro
        }
      })
      return pregoeiro
    },
    responsavelDescricao() {
      const id = this.value && this.value.idResponsavel
      const lista = this.responsaveisPregao || []
      const selecionado = lista.find(responsavel => responsavel.value === id)
      return (selecionado && selecionado.text) || this.pregoeiro || '---'
    },
    labelResponsavelPregao() {
      if (this.ehModalidadeConcorrencia) return 'Agente de Contratação'
      if (this.ehModalidadeLeilao) return 'Leiloeiro'
      return 'Pregoeiro'
    },
    placeholderResponsavel() {
      return this.responsaveisPregao && this.responsaveisPregao.length > 1 ? 'Selecione' : ''
    },
    tipoDisputaDesc() {
      return tiposDisputa[this.value.tipoDisputa]
    },
    permitindoAlterarDadosPublicados() {
      return this.acao === 'alterando-dados'
    },
    permiteEditarDisputaPor() {
      return this.permitindoAlterarDadosPublicados && this.value.status === 'AGUARDANDO_ABERTURA'
    },
    visualizando() {
      return this.acao === 'visualizando'
    },
    getAmparoLegal() {
      if (this.value.amparoLegal) {
        return this.value.amparoLegal.lei
      }
      return '---'
    },
    labelResponsavel() {
      if (this.value.ehPerfilComprasBR) {
        return 'Órgão'
      } else {
        return 'Responsável'
      }
    },
    possuiApenasUmOrgao() {
      return this.orgaosUsuario.length === 1 || this.value.ehPerfilComprasBR
    },
    ehAmparoLei14133Art82() {
      if (this.value && this.value.amparoLegal)
        return this.value.amparoLegal.lei === 'Lei 14.133/2021, Art. 82, IV'
    },
    ehModalidadeConcorrencia() {
      return this.value.modalidade.includes('CONCORRÊNCIA ELETRÔNICA')
    },
    ehModalidadeLeilao() {
      return this.value.modalidade === 'LEILÃO ELETRÔNICO'
    },
    ehPregaoPresencial() {
      return this.value.modalidade === 'PREGÃO PRESENCIAL'
    },
    ehModoDisputaFechado() {
      return this.value.modalidade.includes('CONCORRÊNCIA ELETRÔNICA') && this.value.tipoLicitacao === 'TP'
    },
    getTipoLicitacaoEnum() {
      const {amparoLegal} = this.value;
      if (this.ehModalidadeConcorrencia && this.temAmparoLei14133Incluso(amparoLegal)) {
        return tiposLicitacaoComTecnicaPreco
      }
      if (this.value.modalidade === 'LEILÃO ELETRÔNICO') {
        return tiposLicitacaoLeilao
      } else if (this.temAmparoLei14133Incluso(amparoLegal)) {
        return tiposLicitacaoSemMaiorOferta
      }
      return tiposLicitacao
    },
    getEspecificacoesRamo() {
      const categoria = this.value.categoria;
      if (categoria) {
        this.buscarEspecificacoesRamo(categoria.tipo)
        if (categoria.tipo === 'OBRAS' || categoria.tipo === 'SERVICOS_DE_ENGENHARIA' || categoria.tipo === 'CONCESSOES_E_PERMISSOES_DE_SERVICOS_PUBLICOS') {
          return true
        }
      }
      return false
    },
    ehIntegracaoPrestacaoContasAtiva() {
      return this.parametros.propriedadesLicitacao.integration.integracaoSistemaDePrestacaoContasAtiva
    },
    ehObrigatorioInformarIDContratacaoPNCP(){
      if (!this.parametros.propriedadesLicitacao.permitirInformarIdContratacaoPncp) {
        return false
      }

      const modalidadesExcecao = this.parametros.propriedadesLicitacao.permitirInformarIdContratacaoPncpExcetoModalidades
      const modalidade = this.value.modalidade

      if (!modalidadesExcecao || !modalidade) {
        return true
      }

      return !modalidadesExcecao
        .split(',')
        .map(item => item.trim())
        .filter(item => item)
        .some(item => item === modalidade)
    },
    ehPermitidoInserirEstadoBeneficioLocal(){
      return this.parametros.propriedadesLicitacao.porcentagemBeneficioLocal > 0
    },
    itemsTipoLances() {
      if (this.value.tipoLicitacao === 'MD') {
        return this.tipoLances.filter(item => item.value === true)
      }
      return this.tipoLances
    },
    ...mapState(['licitacao', 'parametros'])
  },
  watch: {
    orgaosUsuario: {
      handler() {
        if (this.possuiApenasUmOrgao && this.orgaosUsuario[0]) {
          this.value.idOrgao = this.value.idOrgao ? this.value.idOrgao : this.$store.state.loki.user.domainId
        }
      },
      deep: false
    },
    'value.dataAbertura': function (novaData) {
      if (!novaData) {
        this.value.dataLimiteEsclarecimentoImpugnacao = null
        return
      }
      let data = moment(novaData).tz(this.$store.state.loki.timezone)
      let diasUteis = 0

      while (diasUteis < 3) {
        data = data.subtract(1, "day")
        if (data.isoWeekday() !== 6 && data.isoWeekday() !== 7) {
          diasUteis++;
        }
      }
      data.set({
        hour: 23,
        minute: 59,
        second: 59,
        millisecond: 59,
      });
      this.value.dataLimiteEsclarecimentoImpugnacao = data.format()
    },
    'value.modoDisputa': {
      handler() {
        if (this.value.tipoLicitacao === 'MD') {
          this.value.diferencaMinimaLancePercentual = true;
        }
      },
      immediate: true
    }
  },
  async mounted() {
    if (this.value && this.value.modoDisputa) {
      this.cachedModoDisputa = this.value.modoDisputa;
    }
    await this.buscarAmparoLegal();
    this.comissoes = await this.buscarComissoesApuracao()
    this.limparComissaoInativa()
    this.ufs = await this.buscarUFs()
    this.orgaoUsuario = await this.buscarOrgaoUsuario();
    this.orgaosUsuario = await this.buscarOrgaosUsuario();
    this.casasDecimais = [
      {text: '2', value: 2},
      {text: '3', value: 3},
      {text: '4', value: 4}
    ];
    this.casasDecimaisQuantidade = [
      {text: '0', value: 0},
      {text: '2', value: 2},
      {text: '3', value: 3},
      {text: '4', value: 4}
    ];
    this.beneficioLocal.ativado = this.value.beneficiosRegionais && this.value.beneficiosRegionais.length > 0;
    this.configurarAmparoLegalModalidade()
    this.configurarListaAmparoLegal(false)
    this.limparAmparoLegalIncompativel()
    await this.buscarCategorias()
    this.iniciarDataPrevisao()
    await this.atualizarResponsaveisPregao()
  },
  methods: {
    preencherPrevisao() {
      if (this.value.dataAbertura && this.value.dataPrevisaoPublicacao >= this.value.dataAbertura) {
        this.value.dataAbertura = null;
      }
      this.dataPrevisaoPreenchida = true;
    },
    iniciarDataPrevisao() {
      if (this.value.dataPrevisaoPublicacao) {
        this.dataPrevisaoPreenchida = true;
      }

      if (this.value.dataAbertura && this.value.dataPrevisaoPublicacao >= this.value.dataAbertura) {
        this.value.dataAbertura = null;
      }
    },
    limparComissaoInativa() {
      const comissaoValida = this.comissoes.some(comissao => {
            return comissao.value === this.value.idComissaoApuracao
          }
      )
      if (!comissaoValida) {
        this.value.idComissaoApuracao = null
      }
    },
    limparAmparoLegalIncompativel() {
      if (this.value.amparoLegal) {
        if (!this.amparosLegais.map(amparo => amparo.id).includes(this.value.amparoLegal.id)) {
          this.value.amparoLegal = null
        }
      }
    },
    ehPerfilFornecedor() {
      return this.$store.state.loki.user.type === 'EXTERNO'
    },
    async buscarAmparoLegal() {
      this.amparoLegalLoading = true
      const dados = await this.$store.dispatch(actionTypes.BUSCAR_AMPARO_LEGAL_SITUACAO, 'ATIVO')
      if (dados) {
        this.amparosLegais = dados
      }
      this.amparoLegalLoading = false
    },
    async buscarComissoesApuracao() {
      const situacaoBuscar = (this.visualizando || this.value.publicado) ? null : 'ATIVO'
      const comissoes = await this.$store.dispatch(actionTypes.BUSCAR_COMISSOES_APURACAO, situacaoBuscar)
      const listaComissoes = []
      comissoes.forEach(comissao => {
        listaComissoes.push({text: comissao.sigla, value: comissao.id, pregoeiro: (comissao.presidente ? comissao.presidente.nome : null)})
      })
      return listaComissoes
    },
    async atualizarResponsaveisPregao() {
      this.responsaveisPregao = []

      if (!this.value || !this.value.idComissaoApuracao) {
        return
      }
      if (this.value.idResponsavel && this.value.nomeResponsavel && (this.visualizando || (this.value.publicado && !this.permitindoAlterarDadosPublicados))) {
        this.responsaveisPregao.push({text: this.value.nomeResponsavel, value: this.value.idResponsavel})
        return
      }
      const resposta = await this.$store.dispatch(actionTypes.BUSCAR_RESPONSAVEIS_COMISSAO, this.value.idComissaoApuracao)
      const itensRetornados = (resposta && resposta.items) ? resposta.items : []

      const listaResponsaveisFormatada = itensRetornados
          .filter(item => item.idResponsavel && item.nome)
          .map(item => ({text: item.nome, value: item.idResponsavel}))
      this.responsaveisPregao = listaResponsaveisFormatada

      if (Array.isArray(listaResponsaveisFormatada) && listaResponsaveisFormatada.length === 1) {
        const val = listaResponsaveisFormatada[0].value
        this.$set(this.value, 'idResponsavel', val)
        return
      }
      if(this.value.idResponsavel){
        const possuiResponsavelSelecionado = this.responsaveisPregao.find(responsavel => responsavel.value === this.value.idResponsavel)
        if(!possuiResponsavelSelecionado){
          this.$set(this.value, 'idResponsavel', null)
        }
      }
    },
    async buscarOrgaoUsuario() {
      if (this.ehPerfilFornecedor()) {
        return
      }
      const uo = await this.$store.dispatch(actionTypes.BUSCAR_ORGAO, {orgaoId: this.$store.state.loki.user.domainId});
      if (!uo) {
        return null
      }
      this.beneficioLocal.ufSelecionada = uo.unidadeOrganizacional.municipio.estado.id;
      await this.buscarMunicipios();
      return uo.unidadeOrganizacional;
    },
    async buscarOrgaosUsuario() {
      const uosUsuario = await this.$store.dispatch(actionTypes.BUSCAR_ORGAOS_USUARIO)
      const orgaos = uosUsuario.orgaos
      let listaUosUsuario = []
      orgaos.forEach(uo => {
        if (uo.id === this.$store.state.loki.user.domainId) {
          this.value.idOrgao = this.value.idOrgao ? this.value.idOrgao : uo.id
        }
        listaUosUsuario.push({text: `${uo.nome} - ${uo.sigla}`, value: uo.id})
      })
      return listaUosUsuario
    },
    async buscarUFs() {
      return await this.$store.dispatch(actionTypes.BUSCAR_UFS);
    },
    async buscarMunicipios() {
      if (!this.beneficioLocal.ufSelecionada) {
        return;
      }
      const data = await this.$store.dispatch(actionTypes.BUSCAR_MUNICIPIOS, {ufId: this.beneficioLocal.ufSelecionada});
      this.$set(this.beneficioLocal, 'municipiosUf', data)
    },
    async configurarCamposAmparoModalidade() {
      await this.buscarAmparoLegal();
      this.configurarListaAmparoLegal(true)
      this.configurarAmparoLegalModalidade()
      this.setarModoDisputaFechado()
      this.setModoDisputaModalidadesNaoExecutaveis()
    },
    configurarListaAmparoLegal(limparCampos) {
      if (this.value.origem !== 'EXTERNA') {
        if (this.value.modalidade === 'CONCORRÊNCIA ELETRÔNICA') {
          const amparoLegal = this.amparosLegais.find(item => item.codigo === '2')
          this.amparosLegais = [amparoLegal]
          this.value.amparoLegal = amparoLegal
          this.value.idAmparoLegal = amparoLegal.id
          if (limparCampos) {
            this.value.tipoLicitacao = null
          }
        } else if (this.value.modalidade === 'LEILÃO ELETRÔNICO') {
          const amparoLegal = this.amparosLegais.find(item => item.codigo === '4')
          this.amparosLegais = [amparoLegal]
          this.value.amparoLegal = amparoLegal
          this.value.idAmparoLegal = amparoLegal.id
          this.value.tipoLicitacao = 'ML'
        }

        if (this.value.modalidade === 'PREGÃO ELETRÔNICO') {
          this.amparosLegais = this.amparosLegais.filter(item => item.codigo !== '2')
          if (limparCampos) {
            this.value.amparoLegal = null
            this.value.idAmparoLegal = null
            this.value.tipoLicitacao = null
          }
        }
      }
    },
    configurarAmparoLegalModalidade() {
      if (!this.visualizando && this.value.amparoLegal) {
        this.value.idAmparoLegal = this.value.amparoLegal.id
        const modoDisputaSelecao = this.modoDisputaAmparoLegal.find(item => item.codigoAmparoLegal === this.value.amparoLegal.codigo)
        if (modoDisputaSelecao) {
          this.modoDisputaPregao = modoDisputaSelecao.modoDisputaAmparo
          if (this.value.modalidade === 'CONCORRÊNCIA ELETRÔNICA' || this.value.modalidade === 'CONCORRÊNCIA PRESENCIAL' || this.value.modalidade === 'CONCURSO' || this.value.modalidade === 'DIÁLOGO COMPETITIVO') {
            this.listarModoDisputaPregaoConcorrencia()
          }
          if (this.value.modalidade.includes('PRESENCIAL') && !this.ehModoDisputaFechado) {
            this.listarModoDisputaLicitacaoPresencial()
          }
          if (this.cachedModoDisputa) {
            this.value.modoDisputa = this.cachedModoDisputa;
          } else {
            if (this.value.modoDisputa === 'RANDOMICO' && modoDisputaSelecao.modoDisputa == null) {
              this.value.modoDisputa = modoDisputaSelecao.modoDisputa
            } else if (this.value.modoDisputa !== 'RANDOMICO' && modoDisputaSelecao.modoDisputa) {
              this.value.modoDisputa = modoDisputaSelecao.modoDisputa
            }
          }
          this.bloquearInversaoDeFases = modoDisputaSelecao.bloquearInversaoDeFases
          if (this.bloquearInversaoDeFases) {
            this.value.inversaoFases = false
          }
          if (this.ehAmparoLei14133Art82) {
            this.value.tipoDisputa = 'VALOR_UNITARIO'
          }
        }
        this.setModoDisputaModalidadesNaoExecutaveis()
      }
    },
    setarModoDisputaFechado() {
      if (this.cachedModoDisputa) {
        this.value.modoDisputa = this.cachedModoDisputa;
        return;
      }

      if (this.value.modalidade === 'CONCORRÊNCIA ELETRÔNICA' || this.value.modalidade === 'CONCORRÊNCIA PRESENCIAL') {
        const isFechado = ['TP', 'MTC', 'CA'].includes(this.value.tipoLicitacao);
        this.value.modoDisputa = isFechado ? 'FECHADO' : null;
        this.modoDisputaPregao.forEach(modo => {
          switch (modo.value) {
            case 'ABERTO_FECHADO':
            case 'FECHADO_ABERTO':
            case 'ABERTO':
              modo.disabled = isFechado;
              break;
            case 'FECHADO':
              modo.disabled = !isFechado;
              break;
          }
        });
        return;
      }
      this.value.modoDisputa = null;
    },
    setarModoDisputaNaoSeAplica() {
      if (this.value.modalidade === 'MANIFESTAÇÃO DE INTERESSE') {
        this.value.modoDisputa = 'NAO_SE_APLICA';
        this.modoDisputaPregao.forEach(modo => {
          switch (modo.value) {
            case 'ABERTO_FECHADO':
            case 'FECHADO_ABERTO':
            case 'ABERTO':
            case 'FECHADO':
              modo.disabled = true;
              break;
            case 'NAO_SE_APLICA':
              modo.disabled = false;
              break;
          }
        });
        return;
      }
      this.value.modoDisputa = null;
    },
    listarModoDisputaPregaoConcorrencia() {
      const isFechado = ['TP', 'MTC', 'CA'].includes(this.value.tipoLicitacao);
      this.value.modoDisputa = isFechado ? 'FECHADO' : null;
      this.modoDisputaPregao.forEach(modo => {
        switch (modo.value) {
          case 'ABERTO_FECHADO':
          case 'FECHADO_ABERTO':
          case 'ABERTO':
            modo.disabled = isFechado;
            break;
          case 'FECHADO':
            modo.disabled = !isFechado;
            break;
        }
      });
    },
    listarModoDisputaLicitacaoPresencial() {
      this.modoDisputaPregao.forEach(modo => {
        switch (modo.value) {
          case 'ABERTO_FECHADO':
            modo.disabled = true
            break
          case 'FECHADO_ABERTO':
            modo.disabled = false
            break
          case 'RANDOMICO':
            modo.disabled = true
            break
          case 'ABERTO':
            modo.disabled = false
            break
          case 'FECHADO':
            modo.disabled = true
            break
        }
      })
    },
    buscarMunicipioPorId(municipioId) {
      if (!this.beneficioLocal.municipiosUf || this.beneficioLocal.municipiosUf.length === 0) {
        return null;
      }
      let municipio = this.beneficioLocal.municipiosUf.find(item => item.id === municipioId);

      const municipioDTO = {
        estado: municipio.estado,
        id: municipio.id,
        idIntegracao: municipio.idIntegracao,
        nome: municipio.nome
      }
      return municipioDTO;
    },
    buscarUfPorId(ufId) {
      if (!this.ufs || this.ufs.length === 0) {
        return null;
      }
      let uf = null;
      this.ufs.some(item => {
        if (item.id === ufId) {
          uf = item;
          return true;
        }
        return false;
      });
      return uf;
    },
    getModoDisputa(modo) {
      return this.modoDisputa[modo]
    },
    getDisputa(disputa) {
      return this.tiposDisputa[disputa]
    },
    getTipoObjeto(tipoObj) {
      return this.tipoObjeto[tipoObj]
    },
    getLegislacao(legi) {
      return this.legislacao[legi]
    },
    getOrigemRecurso(origRec) {
      return this.origemRecurso[origRec]
    },
    getTipoTransferencia(tpTransf) {
      return this.tipoTransferencia[tpTransf]
    },
    getModalidadeLicitacao(modalidade) {
      return this.modalidadesLicitacao[modalidade]
    },
    getTipoLicitacao(tipo) {
      return this.tiposLicitacao[tipo] || tipo;
    },
    anularAtributosRecursoFederal() {
      if (this.value.recursoFederal === false) {
        this.value.tipoTransferencia = null
        this.value.origemRecurso = null
        this.value.numeroConvenio = null
        this.value.numeroCompra = null
        this.value.anoInstrumento = null
        this.value.tipoObjeto = null
        this.value.legislacao = null
      }
    },
    getCidade(ufSigla, cidadeId) {
      if (!cidadeId || !ufSigla) {
        return null;
      }
      const parsedData = JSON.parse(JSON.stringify(this.$data));
      const cidades = parsedData.cidadesUf[ufSigla];
      if (!cidades) {
        return null;
      }
      let cidade = null;
      cidades.forEach(item => {
        if (item.idMunicipio === cidadeId) {
          cidade = item;
        }
      });
      return cidade;
    },
    getUf(id) {
      if (id > 26) {
        return null;
      }
      const parsedData = JSON.parse(JSON.stringify(this.$data));
      return parsedData.ufs[id - 1]; // Array inicia com zero, UF posição 0 até UF posição 26.
    },
    async validarAtivarBeneficioRegional(){
      if(this.ehPermitidoInserirEstadoBeneficioLocal && this.beneficioLocal.ativado){
        this.abrirModalAvisoBeneficioLocal()
      }else {
        await this.ativarBeneficioRegional()
      }
    },
    async ativarBeneficioRegional() {
      this.$set(this.value, 'beneficiosRegionais', []);
      await this.buscarMunicipios();
      if(this.orgaoUsuario){
        this.beneficioLocal.ufSelecionada = this.orgaoUsuario.municipio.estado.id;
      }
      if (this.beneficioLocal.ativado) {
        this.value.beneficiosRegionais.push({
          estado: this.buscarUfPorId(this.orgaoUsuario.municipio.estado.id),
          municipio: this.ehPermitidoInserirEstadoBeneficioLocal ? null : this.buscarMunicipioPorId(this.orgaoUsuario.municipio.id),
          beneficioLocal: true
        });
      } else {
        this.value.beneficioRegional = false
        this.value.regimento = null
      }
      this.fecharModalAvisoBeneficioLocalBeneficioLocal()
    },
    cancelarAtivarBeneficioRegional(){
      this.beneficioLocal.ativado = false
      this.fecharModalAvisoBeneficioLocalBeneficioLocal()
    },
    abrirModalAvisoBeneficioLocal(){
      this.modalAvisoBeneficioLocal = true
    },
    fecharModalAvisoBeneficioLocalBeneficioLocal(){
      this.modalAvisoBeneficioLocal = false
    },
    adicionarBeneficioRegional() {

      if ((!this.beneficioLocal.ufSelecionada || this.beneficioLocal.cidadeSelecionada.length === 0) && !this.ehPermitidoInserirEstadoBeneficioLocal) {
        this.mostrarNotificacaoErro("Selecione um estado e uma cidade.")
        return;
      }

      if(this.ehPermitidoInserirEstadoBeneficioLocal && this.beneficioLocal.cidadeSelecionada.length === 0){
        if (!this.beneficioLocal.ufSelecionada) {
          this.mostrarNotificacaoErro("Selecione um estado.")
          return;
        }
        const beneficiadoLocal = {
          estado: this.buscarUfPorId(this.beneficioLocal.ufSelecionada),
          beneficioLocal: true
        };
        this.value.beneficiosRegionais.push(beneficiadoLocal);
      }

      this.beneficioLocal.cidadeSelecionada.forEach(cidadeId => {
        const municipioJaExiste = this.value.beneficiosRegionais.some(item => item.municipio && item.municipio.id === cidadeId)
        if (!municipioJaExiste) {
            let beneficiado = {
              estado: this.buscarUfPorId(this.beneficioLocal.ufSelecionada),
              municipio: this.buscarMunicipioPorId(cidadeId),
              beneficioLocal: false
            };
          if(!this.ehPermitidoInserirEstadoBeneficioLocal){
            beneficiado.beneficioLocal = beneficiado.estado.id === this.orgaoUsuario.municipio.estado.id && beneficiado.municipio.id === this.orgaoUsuario.municipio.id;
          }
          this.value.beneficiosRegionais.push(beneficiado);
        }
      })

      this.beneficioLocal.cidadeSelecionada = [];
    },
    limparListaBeneficioRegional() {
      this.value.beneficiosRegionais = []
    },
    removerBeneficioLocal(index) {
      this.value.beneficiosRegionais.splice(index, 1);
      if (this.value.beneficiosRegionais.length === 0) {
        this.$delete(this.value, 'beneficioLocalRegional');
      }
    },
    selecionarTodosMunicipiosUf() {
      this.$nextTick(() => {
        if (this.todosMunicipiosSelecionados) {
          this.beneficioLocal.cidadeSelecionada = []
        } else {
          const municipiosUf = []
          this.beneficioLocal.municipiosUf.forEach(municipio => {
            municipiosUf.push(municipio.id)
          })
          this.beneficioLocal.cidadeSelecionada = municipiosUf
        }
      })
    },
    filtroComboAutoComplete(item, queryText) {
      const text = item.nome.toLowerCase()
      const searchText = queryText.toLowerCase()
      return text.indexOf(searchText) > -1
    },
    filtroComboAutoCompleteComissao(item, queryText) {
      const text = item.text.toLowerCase()
      const searchText = queryText.toLowerCase()
      return text.indexOf(searchText) > -1
    },
    controlarRegimento() {
      if (!this.value.beneficioRegional) {
        this.value.regimento = null
      }
    },
    temAmparoLei14133Incluso(amparoLegal) {
      return amparoLegal && /^Lei 14\.133\/2021, Art\. \d+,/.test(amparoLegal.lei);
    },
    setModoDisputaModalidadesNaoExecutaveis() {
      if (this.verificarModalidadesNaoExecutaveis(this.value.modalidade)) {
        this.modoDisputaPregao = this.modoDisputaNaoExecutaveis
        if (this.cachedModoDisputa) {
          this.value.modoDisputa = this.cachedModoDisputa;
        }
        this.setarModoDisputaNaoSeAplica()
      }
    },
    verificarModalidadesNaoExecutaveis(modalidade) {
      return modalidade === 'DIÁLOGO COMPETITIVO' ||
          modalidade === 'CONCURSO' ||
          modalidade === 'MANIFESTAÇÃO DE INTERESSE' ||
          modalidade === 'PRÉ QUALIFICAÇÃO' ||
          modalidade === 'INAPLICABILIDADE DA LICITAÇÃO'
    },
    async buscarCategorias() {
      const categorias = await this.$store.dispatch(actionTypes.BUSCAR_CATEGORIAS)
      this.categorias = categorias.items
    },
    async buscarEspecificacoesRamo(categoriaTipo) {
      const especificacoes = await this.$store.dispatch(actionTypes.BUSCAR_ESPECIFICACOES_RAMO, {categoriaTipo: categoriaTipo})
      this.especificacoesRamo = especificacoes.items
    },
    setarCategoriaId() {
      this.value.categoriaId = this.value.categoria.id;
      this.value.especificacaoRamo = null
      this.value.especificacaoRamoId = null
    },
    setarEspecificacaoRamoId() {
      this.value.especificacaoRamoId = this.value.especificacaoRamo.id;
    },
    formatarDataBSB(value) {
      const format = 'DD/MM/YYYY HH:mm:ss'
      const tzDestino = 'America/Sao_Paulo'

      if (!value) return ''

      const valorStr = value instanceof Date ? value.toISOString() : String(value)

      const possuiOffset = /([+-]\d{2}:?\d{2}|Z)$/i.test(valorStr)
      const dataOrigem = possuiOffset
          ? momentTz(valorStr)
          : momentTz.tz(valorStr, 'YYYY-MM-DDTHH:mm:ss', 'UTC') // assume UTC

      return dataOrigem.tz(tzDestino).format(format)
    },
    formatarDataComSegundos(value) {
      if (!value) return ''
      return moment(value).format('DD/MM/YYYY HH:mm:ss')
    }
  },
  filters: {
    opcaoSimNaoFilter(valor) {
      return opcaoSimNao[valor]
    }
  }
}
</script>
<style lang="stylus">

    .municipio-beneficio
      width 250px

    .selecionar-todos-municipios-btn
      display flex
      flex-direction row
      font-size 14px
      font-weight bold
      color #77797B

    .checkbox-beneficio-posicao
      display flex
      align-self center

    .separadorBeneficioLocal
        margin-left 25px
        padding-left 5px
        display flex
        flex-direction row
        align-items center

    .regimento-beneficio
        display flex
        flex-direction row
        align-items center

    .regimento-label
        margin-bottom 0px
        margin-right 5px

    //.az-date #iddiv span.myclass
    .beneficio-local-card
        border solid #c5c5c5 1px !important
    .beneficio-local-toolbar
        border solid #c5c5c5 1px !important
        border-left 0 !important
        border-top 0 !important
        border-right 0 !important
        padding-bottom 0 !important
    .beneficio-local-toolbar .v-toolbar__content
        padding-left 10px !important
    .beneficio-local-checkbox .v-input__slot
        margin 5px 0px 0px 10px !important
    .beneficio-local-checkbox .v-input--selection-controls__input
        margin-right 0px
    .beneficio-local-checkbox label
        font-size: 12px !important
    .beneficio-local-item
        border solid #c5c5c5 1px
        margin-bottom 10px

    .required-field label:after
      content " *"
      color rgb(255, 98, 98)

</style>
